import React from 'react';

import {
  useCategoriesView,
  Loading,
  Alert,
  Gallery,
  Modal,
  MiniCartModal,
  ProductCustomisationModal,
} from '@fingermarkglobal/cringer.components';

const CustomCategoriesView = () => {
  const {
    state,
    loading,
    formattedCategories,
    showMiniCartModal,
    onCloseMiniCartModal,
    onConfirmMiniCartModal,
    originPath,
    showPriceWarning,
    openProductCustomisationModal,
    customisationProductSelected,
    onCloseProductCustomisationModal,
    onConfirmProductCustomisationModal,
    modalAccessibilityClass,
    formatPrice,
    isCustomisationHeaderEnabled,
    isCategoryTotalizerEnabled,
    isAdditionalMessageEnabled,
    showQuantityControllerLabel,
    galleryMaxColumns,
    showAddonAvailability,
    hideDisabledButtons,
    hidePriceWhenQuantityLessOrEqualDefault,
    hidePriceWhenZero,
    isCouponQuantityDisabled,
  } = useCategoriesView();

  return (
    <>
      <Modal open={showMiniCartModal} className={modalAccessibilityClass} formatPrice={formatPrice}>
        <MiniCartModal
          onCloseCallback={onCloseMiniCartModal}
          onConfirmCallback={onConfirmMiniCartModal}
          origin={originPath}
          showPriceWarning={showPriceWarning}
          disableModifyUpsellOnCart={true}
          isCouponQuantityDisabled={isCouponQuantityDisabled}
          hideDisabledButtons={hideDisabledButtons}
        />
      </Modal>
      <Modal
        open={openProductCustomisationModal}
        className={modalAccessibilityClass}
        formatPrice={formatPrice}
      >
        <ProductCustomisationModal
          product={customisationProductSelected}
          onCloseCallback={onCloseProductCustomisationModal}
          onConfirmCallback={onConfirmProductCustomisationModal}
          showPriceWarning={showPriceWarning}
          isCustomisationHeaderEnabled={isCustomisationHeaderEnabled}
          isCategoryTotalizerEnabled={isCategoryTotalizerEnabled}
          isAdditionalMessageEnabled={isAdditionalMessageEnabled}
          showQuantityControllerLabel={showQuantityControllerLabel}
          showAddonAvailability={showAddonAvailability}
          hidePriceWhenQuantityLessOrEqualDefault={hidePriceWhenQuantityLessOrEqualDefault}
          hidePriceWhenZero={hidePriceWhenZero}
        />
      </Modal>
      {loading && (
        <div className="categories-view--loading">
          <Loading />
        </div>
      )}
      {state?.matches('failure') && (
        <div className="categories-view--failure">
          <Alert type="danger" message={state.context.message} />
        </div>
      )}
      {state?.matches('success') && (
        <Gallery
          items={formattedCategories}
          formatPrice={formatPrice}
          maxColumns={galleryMaxColumns}
        />
      )}
    </>
  );
};

export { CustomCategoriesView };
